import { Component } from '@angular/core';

@Component({
  selector: 'app-chevron-right-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './chevron-right-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class ChevronRightIconComponent {}
